import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { api, errMsg } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMessage("Tautan verifikasi tidak lengkap.");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(() => { setState("ok"); setMessage("Email Anda berhasil diverifikasi."); })
      .catch((e) => { setState("error"); setMessage(errMsg(e)); });
  }, [token]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6" data-testid="verify-email-page">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-slate-100 p-8 text-center">
        <Link to="/" className="inline-flex justify-center mb-8"><Logo className="h-8" /></Link>
        {state === "loading" && (
          <div data-testid="verify-loading"><Loader2 className="w-10 h-10 text-blue-600 animate-spin mx-auto" /><p className="mt-4 text-slate-500">Memverifikasi email Anda…</p></div>
        )}
        {state === "ok" && (
          <div data-testid="verify-success">
            <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
            <h1 className="mt-4 text-2xl font-black text-slate-900">Email Terverifikasi</h1>
            <p className="mt-2 text-slate-500">{message} Akun Anda kini menunggu persetujuan admin sebelum NIG diterbitkan.</p>
            <Link to="/portal" data-testid="verify-goto-portal" className="mt-6 inline-flex items-center justify-center gap-2 bg-blue-600 text-white font-bold py-3 px-6 rounded-xl hover:bg-blue-700 active:scale-95 transition">Buka Portal</Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-error">
            <XCircle className="w-14 h-14 text-red-500 mx-auto" />
            <h1 className="mt-4 text-2xl font-black text-slate-900">Verifikasi Gagal</h1>
            <p className="mt-2 text-slate-500">{message}</p>
            <Link to="/portal" data-testid="verify-goto-portal" className="mt-6 inline-flex items-center justify-center gap-2 bg-blue-600 text-white font-bold py-3 px-6 rounded-xl hover:bg-blue-700 active:scale-95 transition">Ke Portal untuk Kirim Ulang</Link>
          </div>
        )}
      </div>
    </div>
  );
}
